import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import {ref, onMounted} from 'vue';
import useCompanyState from '@/app/my-company/infrastructure/persistence/CompanyState';
import banks from '@/app/shared/domain/data/banks';


export default /*#__PURE__*/_defineComponent({
  __name: 'InputBankCompanyList',
  props: ['modelValue'],
  emits: ['update:modelValue'],
  setup(__props, { emit }) {

const props = __props;

const state = useCompanyState();



const options = ref<any>([]);

onMounted(async () => {
    const data = await state.getAllSimpleAccounts();
    options.value = data.map((account: any) => {
        const name = banks.reduce((name, item) => {
            if (item.value === account.code_bank) {
                return item.title;
            }

            return name;
        }, '');

        return {
            value: account.id.toString(),
            title: name,
        };
    });
});

return (_ctx: any,_cache: any) => {
  const _component_v_select = _resolveComponent("v-select")!

  return (_openBlock(), _createBlock(_component_v_select, {
    "model-value": __props.modelValue,
    label: "Conta",
    items: options.value,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = (value) => emit('update:modelValue', value))
  }, null, 8, ["model-value", "items"]))
}
}

})